import type { RouteRecordRaw } from 'vue-router'
import { BLANK_LAYOUT } from '@/router/constant'

const demo: RouteRecordRaw = {
  path: '/demo',
  name: 'demo',
  redirect: '/demo/index',
  component: BLANK_LAYOUT,
  children: [
    {
      path: '/demo/index',
      component: () => import('@/views/demo/index.vue'),
    },
  ],
}

export default demo
